import React from 'react';
import {Background} from "../components/Background";
import {Header} from "../components/front/Header";
import {Footer} from "../components/front/Footer";
import {Outlet, useRouteError} from "react-router-dom";
import {Error} from "../components/Error";

export const Front = () => {
  const error = useRouteError();

  return (
    <div className="__front__ d-flex flex-column min-vh-100">
      <Background/>
      <Header/>
      <div className="container mb-4">
        <>
          {error && (
            <Error error={error}/>
          )}
          {!error && (
            <Outlet/>
          )}
        </>
      </div>
      <Footer/>
    </div>
  );
}
